// components/PracticeCard.js
import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import SmartImg from "./SmartImg";

const PracticeCard = ({ practice }) => {
  const navigate = useNavigate();

  // Thêm một kiểm tra an toàn để đảm bảo `practice` không phải là null hoặc undefined.
  if (!practice) {
    return null;
  }

  // Tái cấu trúc (destructuring) các thuộc tính từ prop `practice`
  const { id, title, description, image } = practice;

  const handleDetailClick = () => {
    navigate(`/practice/${id}`);
  };

  return (
    <Link to={`/practice/${id}`} className="block">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl h-full flex flex-col">
        <SmartImg
          className="w-full h-48 object-cover rounded-t-xl"
          src={image}
          fallback={`https://placehold.co/400x200/E0E0E0/000?text=${title.replace(/\s/g, "+")}`}
          alt={title}
        />
        <div className="p-6 flex-grow flex flex-col justify-between">
          <div>
            <h3 className="text-xl font-bold text-gray-900 line-clamp-2">
              {title}
            </h3>
            <p className="mt-2 text-sm text-gray-600 line-clamp-3">
              {description}
            </p>
          </div>
          <div className="mt-4 flex items-center justify-end text-gray-500 text-sm">
            <button
              onClick={handleDetailClick}
              className="text-blue-600 font-semibold hover:text-blue-800 transition-colors duration-300 flex items-center"
            >
              Xem chi tiết <ChevronRight size={16} className="ml-1" />
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PracticeCard;
